import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { StorageBrowser } from './storage.service';
const SERVER_URL = environment.apiUrl;

export interface IApiParams {
  path: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  query?: any;
  body?: any;
  noAuth?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(public http: HttpClient, public storageBrowser: StorageBrowser) {}

  public request(params: IApiParams, other?: any): Observable<any> {
    const { path, method, body, query, noAuth,  } = params;
    const token = this.storageBrowser.get('token');
    const headersConfig: any = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'ngsw-bypass': 'true',
    };

    if (!noAuth && token) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }
    const isAbsoluteUrl = path.startsWith('http');


    return this.http.request(method, isAbsoluteUrl ? path : `${SERVER_URL}${path}`, {
      body,
      params: query,
      headers: new HttpHeaders(headersConfig),
      ...other,
    });
  }
}
